import { ComponentStyleConfig } from '@chakra-ui/react';

export const Button: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: 500,
    borderRadius: 4,
    lineHeight: 1.4,
    '&:hover:not(:disabled)': {
      transform: 'scale(1.02)',
    },
    '&:active:not(:disabled)': {
      transform: 'scale(0.97)',
    },
    _disabled: {
      cursor: 'default',
      opacity: 0.36,
    },
    '& .chakra-button__icon': {
      my: 'auto',
      mr: 1,
    },
  },
  variants: {
    brandFab: {
      borderRadius: 4,
      bg: 'M.70',
      color: 'M.10',
      height: 10,
      px: 4,
    },
    link: {
      fontWeight: 400,
      color: 'iconAccent',
      boxShadow: 'none',
      transform: 'none',
      '&:hover:not(:disabled)': {
        transform: 'none',
        boxShadow: 'none',
      },
    },
    ghost: {
      color: 'iconBase',
      '&:hover:not(:disabled)': {
        color: 'textBase',
      },
      '&:focus:not(:disabled)': {
        color: 'textBase',
      },
    },
    text: {
      bg: 'transparent',
      color: 'M.70',
      fontWeight: 400,
      shadow: 'none',
      '&:active:not(:disabled)': {
        shadow: 'none',
        color: 'textBase',
      },
      '&:hover:not(:disabled)': {
        shadow: 'none',
        color: 'textBase',
      },
      '&:focus:not(:disabled)': {
        shadow: 'none',
      },
    },
    unstyled: {
      height: 'initial',
      minWidth: 'initial',
      boxShadow: 'initial',
      '&:hover:not(:disabled)': {
        transform: 'unset',
        boxShadow: 'initial',
      },
      '&:active:not(:disabled)': {
        transform: 'unset',
        boxShadow: 'initial',
      },
      '&:focus:not(:disabled)': {
        boxShadow: 'initial',
      },
    },
    primary: {
      color: 'M.10',
      background: 'M.70',
      boxShadow: 'none',
      '&:hover:not(:disabled)': {
        boxShadow: 'none',
      },
      '&:focus:not(:disabled)': {
        boxShadow: 'none',
      },
      _hover: {
        transform: 'scale(1.02)',
        _disabled: {
          background: 'M.70',
        },
      },
    },
    secondary: {
      color: 'M.70',
      background: 'M.30',
      boxShadow: 'none',
      '&:hover:not(:disabled)': {
        boxShadow: 'none',
      },
      '&:focus:not(:disabled)': {
        boxShadow: 'none',
      },
      _hover: {
        transform: 'scale(1.02)',
        _disabled: {
          background: 'M.30',
        },
      },
    },
  },
  sizes: {
    '2xs': {
      borderRadius: 'full',
      height: '20px',
      width: '20px',
    },
    xs: {
      borderRadius: 'full',
      height: '24px',
      width: '24px',
    },
    sm: {
      borderRadius: '4px',
      height: 8,
      fontSize: 'sm',
      padding: '6px 12px',
      fontWeight: 500,
    },
    md: {
      borderRadius: '4px',
      height: '40px',
      fontSize: 'sm',
      py: 1,
      px: 4,
    },
    lg: {
      height: 12,
      fontSize: 'sm',
      px: 6,
    },
    auto: {
      height: 'auto',
      p: 0,
    },
  },
  defaultProps: {
    size: 'lg',
    variant: 'primary',
  },
};
